import { jsx as _jsx } from "react/jsx-runtime";
import { BreadcrumbContainer, BreadcrumbItem, BreadcrumbLink, BreadcrumbNormal } from './styles';
const Breadcrumb = ({ items }) => (_jsx(BreadcrumbContainer, { children: items.map(({ id, to, label }, index) => {
        const active = index === items.length - 1;
        return (_jsx(BreadcrumbItem, { children: to ? (_jsx(BreadcrumbLink, { to: to, "$active": active, children: label })) : (_jsx(BreadcrumbNormal, { "$active": active, children: label })) }, id));
    }) }));
export default Breadcrumb;
